import type { ReactNode } from "react";

export interface ShipmentComparisonRow {
  key: string;
  label: string;
  before: ReactNode;
  after: ReactNode;
  changed: boolean;
}

export function ShipmentFieldComparison({
  rows,
  fieldLabel,
  beforeLabel,
  afterLabel,
}: {
  rows: ShipmentComparisonRow[];
  fieldLabel: string;
  beforeLabel: string;
  afterLabel: string;
}) {
  return (
    <div className="min-w-0 overflow-hidden rounded-lg border border-default-200">
      <table className="w-full table-fixed border-collapse text-left text-sm">
        <thead className="bg-default-50 text-xs text-default-500">
          <tr>
            <th scope="col" className="w-1/4 px-3 py-2 font-medium">
              {fieldLabel}
            </th>
            <th scope="col" className="px-3 py-2 font-medium">
              {beforeLabel}
            </th>
            <th scope="col" className="px-3 py-2 font-medium">
              {afterLabel}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key} className="border-t border-default-200 align-top">
              <th
                scope="row"
                className="px-3 py-3 text-xs font-medium text-default-600 [overflow-wrap:anywhere]"
              >
                {row.label}
              </th>
              <td
                className={`px-3 py-3 whitespace-pre-wrap [overflow-wrap:anywhere] ${row.changed ? "bg-danger-50/50 text-default-600" : "text-default-500"}`}
              >
                {row.changed ? (
                  <del className="decoration-danger/50">{row.before}</del>
                ) : (
                  row.before
                )}
              </td>
              <td
                className={`px-3 py-3 whitespace-pre-wrap [overflow-wrap:anywhere] ${row.changed ? "bg-success-50 font-medium" : "text-default-500"}`}
              >
                {row.changed ? (
                  <ins className="no-underline">{row.after}</ins>
                ) : (
                  row.after
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
